import React from 'react';

import Loader from '../../components/Loader';

import List from './List';
import Filter from './Filter';



const FilterList = ({
  items,
  loading,
}) => (
  <div className="col filter-side d-flex flex-column">
    <Filter />
    {loading ? <Loader /> : <List items={items} />}    
  </div>  
);

export default FilterList;


// WEBPACK FOOTER //
// ./src/scenes/FilterList/index.js